import { DashboardModel } from '@akin-home/dashboards';

type Layout = {
  i: string;
  h: number;
  w: number;
  x: number;
  y: number;
}[];

export const setDashboardLayoutFromGridLayoutChange = (
  dashboard: DashboardModel,
  layout: Layout,
  orientation: 'portrait' | 'landscape'
): DashboardModel => {
  return {
    ...dashboard,
    layout:
      dashboard.layout?.map((widget) => {
        const layout_item = layout.find((item) => item.i === widget.id);

        if (!layout_item) return widget;

        return {
          ...widget,
          positions: {
            ...widget.positions,
            [orientation]: {
              height: layout_item.h as any,
              width: layout_item.w as any,
              top: layout_item.y as any,
              left: layout_item.x as any,
            },
          },
        };
      }) || [],
  };
};
